import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { EventsService } from '@modules/calendar-app/services/events.service';
import { CalendarAppStateService } from '@modules/calendar-app/services/state.service';
import { Calendar } from '@modules/calendar-app/types/calendar';
import { CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { ListState } from '@modules/calendar-app/types/list-state';
import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { CalendarEventsService } from '@modules/form-controls/services/calendar-events.service';
import { Message } from '@modules/messages/types/message';
import { getStitchInstanceByStitchType } from '@modules/common/utils/stitch';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-calendar-app-main-view',
  templateUrl: './main-view.component.html',
  providers: [{ provide: CalendarEventsService, useClass: EventsService }],
  standalone: false,
})
export class MainViewComponent extends AbstractMainViewComponent<
  StitchType.CALENDAR | StitchType.EVENT | StitchType.MESSAGE,
  Calendar | CalendarEvent | Message,
  FullFormBaseComponent<
    StitchType.CALENDAR | StitchType.EVENT | StitchType.MESSAGE,
    Calendar | CalendarEvent | Message,
    Record<string, AbstractControl>
  >,
  ListState
> {
  protected override readonly stateService = inject(CalendarAppStateService);

  protected readonly virtualFolder = toSignal(this.stateService.getVirtualFolder());

  public asCalendarEvent(item: Calendar | CalendarEvent | Message): CalendarEvent {
    return item as CalendarEvent;
  }

  public asCalendar(item: Calendar | CalendarEvent | Message): Calendar {
    return item as Calendar;
  }

  /** Invitation emails opened from the Received/Sent Invites folders (SBUX-911). */
  public asMessage(item: Calendar | CalendarEvent | Message): Message {
    return item as Message;
  }

  protected handleNewCalendar(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.CALENDAR));
  }

  protected handleNewEvent(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.EVENT));
  }
}
